export const experienceData = [
    {
        id: 1,
        company: 'CHEGG',
        jobtitle: 'Subject Matter Expert',
        startYear: '2022',
        endYear: 'presnt'
    },
    {
        id: 2,
        company: 'Coding Ninjas',
        jobtitle: 'Teaching Assistant',
        startYear: '2021',
        endYear: '2022'
    },
    // {
    //     id: 3,
    //     company: 'Wonka Industries',
    //     jobtitle: 'Marketing',
    //     startYear: '2020',
    //     endYear: 'Present'
    // },
]